import React from 'react'
import PropTypes from 'prop-types'
import { FaIcon } from '../../../shared/components'
import { GGButton } from '../../../shared/new_components/GGButton'

const GgGolfHubPopup = ({
  isOpen,
  onClose,
  title,
  confirmText,
  onConfirm,
  isConfirmDisabled,
  children,
}) => {
  if (!isOpen) { return null }
  return (
    <div className='gg-golf-hub-overlay'>
      <div className='popup'>
        <div className='header'>
          <h2 className='title'>{title}</h2>
          <button className='close-button' onClick={onClose} aria-label={window.I18n.t('gg_golf_hub.dashboard.close')}>
            <FaIcon icon='xmark-o' usePro/>
          </button>
        </div>
        <div className='separator'></div>
        <div className='body'>
          {children}
        </div>
        <div className='separator'></div>
        <div className='footer'>
          <GGButton
            label={window.I18n.t('gg_golf_hub.dashboard.cancel')}
            onClick={onClose}
            variant='secondary'
          />
          <GGButton
            label={confirmText || window.I18n.t('gg_golf_hub.dashboard.confirm')}
            onClick={onConfirm}
            disabled={isConfirmDisabled}
          />
        </div>
      </div>
    </div>
  )
}

GgGolfHubPopup.propTypes = {
  isOpen: PropTypes.bool,
  isConfirmDisabled: PropTypes.bool,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
  title: PropTypes.string,
  confirmText: PropTypes.string,
  children: PropTypes.node,

}

export default GgGolfHubPopup
